/**
 * Короткие номера заказов и пользователей (правка №13, Элина 16.10.2026).
 *
 * Шлюз отдаёт `number` заказа и пользователя — шесть цифр (миграция 285).
 * Людям показываем их; служебные id («ord_…», «usr_…») остаются в адресах и
 * запросах. Пока номера нет (старый снимок, мок) — id без служебного префикса.
 */
export const orderNo = (id: string, number?: number | null): string =>
	number ? String(number) : id.replace(/^ord_/, "");

/** Номер пользователя; без номера — id как есть (по нему консоль ищет). */
export const userNo = (id: string, number?: number | null): string => (number ? String(number) : id);
